import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextSubHeaderProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextSubHeader = ({
  label,
  color = 'text-ds-natural-600',
  ellipsis,
}: TextSubHeaderProps) => (
  <Typography
    color={color}
    label={label}
    tagName="h3"
    fontSize="text-ds-600"
    lineHeight="leading-ds-500"
    fontWeight="font-ds-medium"
    ellipsis={ellipsis}
  />
);
